import { Component, inject, OnInit } from '@angular/core'
import { PermissionsService } from '@client/Services/PermissionsService'
import { PageComponent } from '@client/Components/ui/Page/Page.Component'
import { GuestsTableComponent } from '@client/Components/Guests/GuestsTable.Component'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { CountdownComponent } from '@client/Components/ui/Countdown/Countdown.Component'

import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'
import { Router } from '@angular/router'

@Component({
	selector: 'my-account',
	templateUrl: './Account.Component.html',
	imports: [
		PageComponent,
		GuestsTableComponent,
		CountdownComponent,
		RaisedButtonComponent,
	],
})
export class AccountComponent implements OnInit {
	protected readonly permissionsService: PermissionsService

	protected date: Date

	private readonly systemConfigService: SystemConfigService

	private readonly router: Router

	constructor() {
		this.permissionsService = inject(PermissionsService)
		this.systemConfigService = inject(SystemConfigService)
		this.router = inject(Router)
	}

	public ngOnInit() {
		this.date = new Date(this.systemConfigService.config.event.date)
	}

	protected readonly setupPayments = async () => {
		await this.router.navigateByUrl('/my-account/orders')
	}
}
